import { ArrowLeftOutlined } from '@ant-design/icons';
import { ExternalUserLoginForm } from '@framework/auth';
import { EidasLoginButton } from '@framework/auth-open-web';
import { i18next } from '@framework/i18n';
import { IFrontLoginFormProps } from '@framework/theme/src/front/FrontLoginForm';
import { VerticalSpace, useHistory } from '@framework/ui';
import { useState } from 'react';
import { FixedHeightBlock } from './FixedHeightBlock';
import { LoginBlock } from './LoginBlock';
import { StyledButtonLikeLink } from './StyledButtonLikeLink';

/**
 * Form di login utenti esteri frontoffice.
 */
export function LoginBlockStepsForeignUsers(props: IFrontLoginFormProps) {
  const { resolvePublicUrl, onLogin } = props;
  const [formVisible, setFormVisible] = useState(false);
  const [backButtonFocus, setBackButtonFocus] = useState(false);
  const history = useHistory();

  // A11Y Accessibilità per il focus pulsante back
  const handleSetVisible = (visible: boolean) => {
    setFormVisible(visible);
    setBackButtonFocus(!visible);
  };

  /**
   * Funzione per impostare la lingua inglese al cambio pagina
   */
  const handleChangePageEnGbLink = (to: string) => {
    if (!to) return null;
    // Cambio lingua per l'utente extra-UE
    // solo se la lingua corrente è diversa da 'en-GB'
    // per evitare il reload della pagina se non necessario
    const needChange = i18next.language !== 'en-GB';
    if (needChange) {
      i18next.changeLanguage('en-GB');
    }
    history.push(to as any);
    if (needChange) {
      window.location.reload();
    }
  };

  return (
    <>
      {!formVisible ? (
        <LoginBlock
          before={
            <div>
              <b>UE users</b>
              <br />
              eIDAS allows access with the digital identity of another European
              Union country.
            </div>
          }
          link={
            <a
              href={'https://www.eid.gov.it/en'}
              target="_blank"
              rel="noreferrer"
            >
              Learn more about eIDAS
            </a>
          }
          button={
            <EidasLoginButton resolvePublicUrl={resolvePublicUrl} fullWidth />
          }
          after={
            <div>
              <b>Extra UE users</b>
              <br />
              If you are a user from outside the EU or from a country not
              covered by the eIDAS node, use this access method.
              <br />
              <VerticalSpace size={12} />
              <StyledButtonLikeLink
                autoFocus={backButtonFocus}
                id="external-user-login-button"
                // aria-controls="external-user-login-region"
                onClick={() => handleSetVisible(true)}
              >
                Sign in
              </StyledButtonLikeLink>{' '}
              or{' '}
              <StyledButtonLikeLink
                onClick={() => {
                  handleChangePageEnGbLink('/utente/registrazione');
                }}
              >
                Sign up
              </StyledButtonLikeLink>
              <VerticalSpace size={12} />
            </div>
          }
        />
      ) : (
        <div
          role="region"
          id="external-user-login-region"
          aria-labelledby="external-user-login-button"
          aria-expanded={formVisible}
        >
          <LoginBlock
            before={
              <div>
                <FixedHeightBlock>
                  <b>
                    <a href="#" onClick={() => handleSetVisible(false)}>
                      <ArrowLeftOutlined aria-hidden="true" /> Back
                    </a>
                  </b>
                  <br />
                  If you are a user from outside the EU or from a country not
                  covered by the eIDAS node, use the credentials that have been
                  issued to you.
                </FixedHeightBlock>
                <VerticalSpace size={12} />
                <ExternalUserLoginForm
                  onLogin={onLogin!}
                  hideInfos
                  submitButtonText="Sign in"
                />
                If you do not have credentials, proceed to{' '}
                <StyledButtonLikeLink
                  onClick={() => {
                    handleChangePageEnGbLink('/utente/registrazione');
                  }}
                >
                  sign up
                </StyledButtonLikeLink>{' '}
                or{' '}
                <StyledButtonLikeLink
                  onClick={() => {
                    handleChangePageEnGbLink('/utente/recupera-password');
                  }}
                >
                  reset your password
                </StyledButtonLikeLink>{' '}
                if you forgot it.
              </div>
            }
          />
          <VerticalSpace size={12} />
        </div>
      )}
    </>
  );
}
